<template lang="pug">
  vm-prompt( vm-size="small" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalAssignVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-select(url="assignmet-types" column="name" autocomplete :placeholder='$t("customers.assignmet_type_id_placeholder")' v-model="form.assignmet_type_id" :label='$t("customers.assignmet_type_id")' @input-change="autoCompleteFunc")
                vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in customersCatalog.assignmetTypes")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-typeahead(url="users" :label="$t('strings.user')" :serializer="item => item.name" :data="customersCatalog.users" :placeholder="$t('customers.assigned_to_placeholder')" :danger="!$v.form.assigned_to.required" :danger-text="$t('validation.required', { attribute: $t('customers.assigned_to') })" v-model="form.assigned_to" :filter="query => `?param=${query},name`" @input-change="autoCompleteFunc" :defaultValue="form.assigned_to && form.seller ? form.seller.name : ''")
              template(slot-scope="{data}")
                vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalAssignCustomer',
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  validations: {
    form: {
      assigned_to: {
        required
      },
      assignmet_type_id: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalAssignVisible',
      'customersCatalog'
    ]),
    getTitle () {
      return this.$t('customers.assign')
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'assignCustomer',
      'setModalAssignVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.assignCustomer(this.form)
    },
    async getCatalog () {
      Object.keys(this.customersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalAssignVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.vm-col{
  padding: 0px 10px;
}
</style>
